import { environment } from '@env/environment';
export const HEADER_NAV_FOOTER_ENV_REPLACE: any = {
  ms_guests: {
    cart_enabled: false,
  },
  gds_footer: {
    enabled: false,
    content_id: environment.gds_footer.content_id,
    cookie_name: 'display_global_footer',
    use_tridion_config: false,
  },
  tridion: {
    app_directory: '',
    config_enabled: false,
    config_url:
      '/ush/en/us/api/getcontent/?contentIds=upr-gds-microsite-configurator',
    dynamic_path_enabled: false,
    publication: environment.tridion.publication,
  },
  gds_global_nav: {
    enabled: false,
    cookie_name: 'display_global_nav',
    utility_bar_content_id:
      environment.contentIds.GDS_GLOBAL_NAV_UTILITY_BAR_CONTENT_ID,
    mega_nav_content_id:
      environment.contentIds.GDS_GLOBAL_NAV_MEGA_NAV_CONTENT_ID,
    use_tridion_config: false,
    use_ms_places: false,
    app: {
      web_store: 'checkout-login,payment-options,checkout-confirmation',
      packages: 'checkout-login,payment-options,confirmation',
      hotels: 'checkout-login,checkout,confirmation',
    },
  },
  sap_cart: {
    occ_base_url: environment.sap_cart.occ_base_url,
    base_site: environment.sap_cart.base_site,
    jdk21Enabled: environment.jdk21Enabled,
  },
};
